import React, {useEffect} from "react";
import {setCb} from "./index";
import toast from 'react-hot-toast'


const ToastContainer = () => {
	useEffect(()=>{
		setCb((message,type)=>{
			if(type){
				toast.success(message,{
					position: "top-center",
					icon: '👋',
					style: {
						borderRadius: '10px',
						background: '#333',
						color: '#fff',
					},
				})
			}else{
				toast.error(message,{
					position: "top-center"
				})
			}
		})
		return () => {
			setCb(undefined)
		}
	},[])
	return(
		<div/>
	)

}

export {
	ToastContainer
}
